export default {
  addedToQueue: {
    en: 'scheduled for {scheduledDate}',
  },
  addedToCart: {
    en: 'was added to cart',
  },
  viewQueue: {
    en: 'View your queue',
  },
}
